import Level2 from './Level2'
export { Level2 }
export default Level2
